// Vue 2 BootstrapVue's `BootstrapVue` plugin auto-registered every `B*`
// component globally; templates could use kebab-case (`<b-button>`,
// `<b-input-group-text>`) anywhere without local imports.
//
// bootstrap-vue-next 0.30's `createBootstrap()` only installs plugins
// (modal controller, popover, toast, rtl, breadcrumb, show-hide), it does
// NOT auto-register components. Upstream's recommendation is local imports
// or `unplugin-vue-components` with a resolver — both invasive for an
// existing Options-API codebase with 35 .vue files.
//
// Re-create the Vue 2 BootstrapVue surface for ONLY the components actually
// used by the codebase (allow-list below). Vue's resolver normalizes
// kebab-case to PascalCase, so `<b-spinner>` → `BSpinner`. Directives
// (`v-b-tooltip`, `v-b-popover`, `v-b-toggle`, `v-b-modal`,
// `v-b-scrollspy`, `v-b-color-mode`) are registered separately by their
// `vB<Name>Directive` exports.
//
// Why allow-list instead of `if (/^B[A-Z]/.test(exportName))`:
//   bvn 0.30 exports 102 B* components; the codebase uses 31 (verified
//   via `grep -rohE '<b-[a-z][a-z0-9-]+'`). Registering all 102 inflates
//   the global component map and the template-compiler's slot-resolution
//   work in every component using a global, which compounds under
//   Cypress/Vitest where many components mount per spec. The OOM crash
//   on `processor.spec.js` (shard 1/6) in CI was traced to renderer-side
//   heap pressure; trimming this map is one of several mitigations (the
//   others being `numTestsKeptInMemory=0` and V8 `--max-old-space-size`,
//   landed in 7.41).
//
// To add a new B* component: grep its usage, append to GLOBAL_COMPONENTS.
// Two known latent usages — `<b-icon>` (no `BIcon` export in bvn 0.30;
// see CustomReport.vue) and `<b-checkbox>` (only `BFormCheckbox` exists;
// see SearchBox.vue) — are NOT registered here. Both are pre-existing
// bugs from the Vue 2 → 3 migration, tracked as separate follow-ups; the
// branches that render them are guarded and never hit by current specs.
//
// Install AFTER `createBootstrap()` so the controller plugins still own
// their injection keys (component registration is pure and side-effect
// free w.r.t. those plugins).
import {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCollapse,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInput,
  BInputGroup,
  BInputGroupText,
  BLink,
  BModal,
  BPagination,
  BPopover,
  BProgress,
  BProgressBar,
  BSpinner,
  BTab,
  BTabs,
  vBToggle,
  vBTooltip,
  vBPopover,
  vBModal,
  vBScrollspy,
  vBColorMode,
} from 'bootstrap-vue-next';

const GLOBAL_COMPONENTS = {
  BAlert,
  BBadge,
  BButton,
  BCard,
  BCollapse,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInput,
  BInputGroup,
  BInputGroupText,
  BLink,
  BModal,
  BPagination,
  BPopover,
  BProgress,
  BProgressBar,
  BSpinner,
  BTab,
  BTabs,
};

const GLOBAL_DIRECTIVES = {
  'b-toggle': vBToggle,
  'b-tooltip': vBTooltip,
  'b-popover': vBPopover,
  'b-modal': vBModal,
  'b-scrollspy': vBScrollspy,
  'b-color-mode': vBColorMode,
};

export default {
  install(app) {
    for (const [name, component] of Object.entries(GLOBAL_COMPONENTS)) {
      if (component) {
        app.component(name, component);
      }
    }
    for (const [name, directive] of Object.entries(GLOBAL_DIRECTIVES)) {
      if (directive) {
        app.directive(name, directive);
      }
    }
  },
};
